function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 .5h34A7.5 7.5 0 0149.5 8v34a7.5 7.5 0 01-7.5 7.5H8A7.5 7.5 0 01.5 42V8A7.5 7.5 0 018 .5z",
  fill: "url(#ICP_svg__paint0_linear_3_46856)",
  stroke: "url(#ICP_svg__paint1_linear_3_46856)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.69 14l-.377.006c-2.781.15-4.918 2.588-4.773 5.448a9.287 9.287 0 001.909 6.292c.156.424.161.891.013 1.318l-1.246.487c-2.541 1.027-4.066 1.888-4.807 3.11l-.157.29-.11.266a2.592 2.592 0 00-.142.848c0 1.313.975 2.395 2.23 2.543l.294.017h10.53c-.343-.343-.69-.712-1.024-1.094-.619-.707-1.206-1.472-1.643-2.207-.422-.712-.762-1.49-.762-2.199 0-1.77 1.194-3.823 3.582-4.095a9.35 9.35 0 001.405-5.576c.01-.18.01-.36 0-.54-.138-2.73-2.306-4.856-4.922-4.914zM25 29.125c0 2.063 4.125 6.187 5.5 6.875 1.375-.688 5.5-4.813 5.5-6.875a2.75 2.75 0 10-5.5 0 2.75 2.75 0 10-5.5 0z",
  fill: "url(#ICP_svg__paint2_linear_3_46856)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "ICP_svg__paint0_linear_3_46856",
  x1: -25,
  y1: 25,
  x2: 25,
  y2: 75,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F5FBFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E8F1FC"
})), React.createElement("linearGradient", {
  id: "ICP_svg__paint1_linear_3_46856",
  x1: 0,
  y1: 0,
  x2: 0,
  y2: 50,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#62BBF8",
  stopOpacity: 0.2
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3386EE",
  stopOpacity: 0.2
})), React.createElement("linearGradient", {
  id: "ICP_svg__paint2_linear_3_46856",
  x1: 3,
  y1: 25,
  x2: 25,
  y2: 47,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4DB1FD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#148CFC"
})));

var SvgIcp = function SvgIcp(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2, _ref3);
};

export default SvgIcp;